import Header from './header'
import Navigation from './navigation'
import Item from './item'
import documentImg from '../assets/document.svg'
import labelsImg from '../assets/labels.png'
import distributionImg from '../assets/supplier.svg'

function Guide(props) {
  return (
    <div className="layout">
      <Header />
      <div className="content">
        <div className="animate__animated animate__backInUp category">
          <div className="group">
            <h3>P&SS Product Code Wizard</h3>
            <div className="row item-list">
              <Item 
                id = '100'
                name = 'Document Management'
                tips = 'Non-distribution, cold chain or label item.'
                image = { documentImg }
                link = '/document'
              />
              <Item 
                id = '200'
                name = 'Labels/Tape/Tags/Tickets'
                tips = 'Tags & Tickets - Blank or Press Printed.'
                image = { labelsImg }
                link = '/label'
              />
              <Item 
                id = '300'
                name = 'Distribution Services'
                tips = 'Distribution services, product category.'
                image = { distributionImg }
                link = '/distribution'
              />
            </div>
          </div>
          <Navigation 
            prev = 'Welcome'
            prevStep = ''
          />
        </div>
      </div>
    </div>
  )
}

export default Guide